module.exports = __webpack_public_path__ + "static/media/arthur2.8b7471e0.jpg";